// extracted by mini-css-extract-plugin
export default {"container":"contact_container__whSmJ","form_ebook":"contact_form_ebook__XXZuy","image_container":"contact_image_container__2gIme","image":"contact_image__fPdjB"};